// Central site content — edit here when the real Amazon link / ISBN arrive.
export const SITE = {
  brand: "My Logic Legacy",
  title: "New Golden Age",
  titleLines: ["New", "Golden", "Age"],
  author: "Ian Jones",
  tagline: "A New Era. A Timeless Wealth.",
  email: "Mylogiclegacy@gmail.com",
  // Live Amazon direct product links (confirmed on Amazon).
  amazonUrl: "https://www.amazon.com/dp/B0HFFKQXX6",
  amazonUrlEbook: "https://www.amazon.com/dp/B0HFFKQXX6",
  amazonUrlPaperback: "https://www.amazon.com/dp/B0HFH9JKD3",
  amazonLabel: "Buy on Amazon",
  isbnEbook: null,
  isbnPaperback: "979-8192590379",
  isbnStatus: "Available now on Amazon",
  // Launch date for the countdown. Leave "" to auto-target the upcoming Monday,
  // or set an ISO date like "2026-06-15T09:00:00" once confirmed.
  // Countdown control:
  //  - launchConfirmed: false  -> shows a graceful "Launching soon" (no ticking clock)
  //  - launchConfirmed: true   -> shows the live countdown to launchDate below
  launchConfirmed: true,
  launchDate: "2026-08-10T09:00:00+10:00",
  pages: "62 pages",
  coverImage:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_new-golden-age/artifacts/pa4fay8a_marvel.png",
  intro:
    "Throughout history, civilizations have risen and fallen — but gold has remained the ultimate symbol of wealth, security, and prosperity.",
  blurb: [
    "What if the financial, political, and social systems we have always known are only the beginning of a much larger story?",
    "In New Golden Age, Ian Jones presents a provocative personal exploration of global power, banking, political transformation, financial sovereignty, and the extraordinary changes he believes may reshape humanity's future.",
    "Drawing on years of independent research, he examines the forces he believes have influenced governments, banking systems, media, and global wealth for generations — inviting readers to question how power is accumulated, how information is controlled, and what genuine individual sovereignty might look like.",
    "Jones explores NESARA/GESARA, the Quantum Financial System, gold-backed currency, digital wallets, financial reform, personal sovereignty, and global wealth redistribution — imagining a world where prosperity becomes a tool for helping others rather than simply accumulating wealth.",
    "Challenging, unconventional, hopeful, and deeply personal, this is a book for anyone interested in alternative political history, hidden power structures, the future of money, and competing visions of the world ahead.",
  ],
  excerpt:
    "I start with what I believe is the world's stark truth, and how things brought us to where we are today. My aim is not to make you feel down. In the end, I hope to lift you up.",
  dedication:
    "I offer this information from my personal research to the readers wanting much more background to this impending Age on our doorstep — to the citizens of Earth.",
  closing: "Could humanity be approaching a new era of freedom, prosperity, cooperation, and renewal?",
  authorBio: [
    "It has not been that long since I first felt the urge to write. I discovered this third book within me, and I enjoy the idea of sharing my knowledge with others.",
    "A few years ago, I wrote two other books — both works of non-fiction as well. Please read through this book, even though some of the material toward the end has not yet become reality. I believe it eventually will.",
  ],
};

export const FORMATS = [
  { name: "eBook", price: "$6.75", note: "Available on Amazon Kindle", tag: "Most popular", href: SITE.amazonUrlEbook, isbn: SITE.isbnEbook },
  { name: "Paperback", price: "$18.65", note: "Ships worldwide via Amazon", tag: null, href: SITE.amazonUrlPaperback, isbn: SITE.isbnPaperback },
  { name: "Audiobook", price: "Coming soon", note: "Narrated edition in production", tag: null, href: null, isbn: null },
];

// Add each store link here as your publisher distributes to the platforms.
// Set `href` to null to show it as "Coming soon" until the link is live.
export const RETAILERS = [
  { name: "Amazon", href: SITE.amazonUrl },
  { name: "Apple Books", href: null },
  { name: "Kobo", href: null },
  { name: "Barnes & Noble", href: null },
  { name: "Google Play Books", href: null },
  { name: "Everand", href: null },
];

// Your two earlier non-fiction books — edit title / description / link.
// Covers kept privately in /app/private_docs/covers (removed from public web access
// while these titles are NOT to be released yet). Restore a cover path when going live.
// Flip SHOW_OTHER_BOOKS to true when these are ready to appear on the site.
export const SHOW_OTHER_BOOKS = false;

export const OTHER_BOOKS = [
  {
    title: "Between Quotation Marks",
    description: "Over 400 original, home-made quotes by Ian Jones — a pocketful of wit and wisdom to help students and anyone facing bullies find a calmer point of view.",
    cover: "",
    href: null,
  },
  {
    title: "Outback Down Under",
    description: "A factual account of nine years driving road trains through Western Australia's outback — from New South Wales to the goldfields and back to Perth.",
    cover: "",
    href: null,
  },
];


export const CHAPTERS = [
  { n: "01", title: "Planet of Slaves" },
  { n: "02", title: "Enforced Deals" },
  { n: "03", title: "The Truthers" },
  { n: "04", title: "The Secret" },
  { n: "05", title: "Towards Positivity" },
  { n: "06", title: "Amazing Insight" },
  { n: "07", title: "Treasonous" },
  { n: "08", title: "Impending Wealth" },
  { n: "09", title: "Nesara Gesara" },
  { n: "10", title: "Prosperity Abound" },
  { n: "11", title: "Banks And You" },
  { n: "12", title: "The Bypass" },
  { n: "13", title: "Self First" },
  { n: "14", title: "A Recap" },
];
